import React from 'react';
import TextField from '@material-ui/core/TextField';

const TextInput = (props) => {
  return <TextField variant="outlined" {...props} />;
};

export default TextInput;
